import { TextField } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export default function SearchBar({
  getData,
  margin = 2,
  size = "small",
  label = "Search",
  variant = "outlined",
  lsVal,
  testId,
}) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [inputValue, setInputValue] = useState(getInputvalue());
  const inputValueRef = useRef(inputValue);
  const timeoutRef = useRef(null);
  const searchDebounceTimeoutMs = 500;
  const lastCalledValueRef = useRef("");

  useEffect(() => {
    inputValueRef.current = inputValue;
  }, [inputValue]);

  useEffect(() => {
    
    clearTimeoutRef();
    
    checkDeleteParams();

    timeoutRef.current = setTimeout(() => {
      setValueToParams();
    }, searchDebounceTimeoutMs);

    return () => {
      clearTimeoutRef();
    };
  }, [getData, inputValue, lsVal, searchParams, setSearchParams]);

//This is done so that reset button resets the search bar.
useEffect(() => {
  const urlParamValue = searchParams.get(lsVal) || "";
  if (inputValueRef.current !== urlParamValue) {
    setInputValue(urlParamValue);
  }
}, [searchParams, lsVal]); 

  function handleInputValue(event) {
    setInputValue(event.target.value);
  }

  function checkDeleteParams() {
     if (String(inputValue) === "" && String(lastCalledValueRef.current) !== "") {
      clearInput();
      lastCalledValueRef.current = "";
      return;
    }
  }

  function setValueToParams() {
    if (String(lastCalledValueRef.current) !== String(inputValue)) {
        searchParams.set(lsVal, inputValue);
        setSearchParams(searchParams);
        getData(inputValue);
        lastCalledValueRef.current = inputValue;
    }
  }

  function getInputvalue() {
    const param = searchParams.get(lsVal);
    if (param) {
      return param;
    }
    return "";
  }

  function clearInput() {
    clearTimeoutRef();
    setInputValue("");
    getData("");
    searchParams.delete(lsVal);
    setSearchParams(searchParams);
  }

  function clearTimeoutRef() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }

  return (
    <TextField
      variant={variant}
      label={t(label)}
      size={size}
      sx={{ width: "100%", m: margin }}
      value={inputValue}
      onChange={handleInputValue}
      inputProps={{ "data-testid": testId }}
      InputProps={{
        endAdornment: (
          <button
            onClick={clearInput}
            data-testid={testId && `${testId}.clear-button`}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            X
          </button>
        ),
      }}
    />
  );
}
